import React from 'react';
import { Box } from "@mui/material";
import LmsKitLabel from "../../components/features/LmsKitLabel"

const QRGenerationDetails = () => {

  return (
    <Box>
      <LmsKitLabel />
    </Box>
  );
};

export default QRGenerationDetails;